"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var spacing = _ref.spacing,
      palette = _ref.palette;
  return (0, _styles.createStyles)({
    root: {
      fontSize: 18,
      fontWeight: 'bold',
      textTransform: 'uppercase',
      color: palette.grey.main,
      marginBottom: spacing(2)
    }
  });
});

var SectionTitle = function SectionTitle(_ref2) {
  var children = _ref2.children,
      props = (0, _objectWithoutProperties2.default)(_ref2, ["children"]);
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_material.Box, (0, _extends2.default)({
    className: classes.root
  }, props), children);
};

var _default = SectionTitle;
exports.default = _default;